<script>
  import { apiFetch } from "../lib/api.js";
  import { user } from "../stores/user"
  import { BASE_URL } from "../stores/BASE_URL"
  import getFecha from "../services/fecha"
  import { onMount } from "svelte"
  import { navigate } from "svelte-routing"
  import Navbar from "../components/Navbar.svelte"
  import CardContent from "../components/CardContent.svelte"

  let isAdding = false

  let cliente = {
    documento: "",
    empresa: "",
    razon_social: "",
  }

  const handleSubmit = () => {
    addCliente()
  }

  const handleCancel = () => {
    navigate(`/clientes`, { replace: true })
  }

  const addCliente = async () => {
    if (
      cliente.documento.trim() === "" ||
      cliente.empresa.trim() === "" ||
      cliente.razon_social.trim() === ""
    ) {
      alert("Completar todos los campos")
      return
    }
    isAdding = true
    const formData = new FormData()
    formData.append("documento", cliente.documento)
    formData.append("empresa", cliente.empresa)
    formData.append("razon_social", cliente.razon_social)
    formData.append("action", "addCliente")
    formData.append("session_id_usuario", $user.idUsuario)

    const response = await apiFetch(`${BASE_URL}cliente.php`, {
      method: "POST",
      body: formData,
    })

    const resp = await response.json()
    if (resp.status == "success") {
      navigate(`/clientes`, { replace: true })
    }

    isAdding = false
  }

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true })
    }
  })
</script>

{#if $user}
  <Navbar />
  <div class="container-fluid py-3">
    <CardContent title="Agregar cliente">
      <form on:submit|preventDefault={handleSubmit}>
        <div class="row mt-3">
          <div class="col-12 col-sm-12 col-md-6 col-lg-3 mb-3">
            <label class="w-100">
              <span class="form-label"> Documento </span>
              <input
                type="text"
                class="form-control"
                bind:value={cliente.documento}
              />
            </label>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-3 mb-3">
            <label class="w-100">
              <span class="form-label">Empresa</span>
              <input
                type="text"
                class="form-control"
                bind:value={cliente.empresa}
              />
            </label>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-3">
            <label class="w-100">
              <span class="form-label">Razon Social</span>
              <input
                class="form-control"
                type="text"
                bind:value={cliente.razon_social}
              />
            </label>
          </div>
          <div class="col-12 mb-3 text-end">
            <button
              type="button"
              class="btn btn-secondary"
              on:click={handleCancel}>Cancelar</button
            >
            {#if isAdding}
              <button type="submit" class="btn btn-primary" disabled>
                Agregando...
              </button>
            {:else}
              <button type="submit" class="btn btn-primary">Agregar</button>
            {/if}
          </div>
        </div>
      </form>
    </CardContent>
  </div>
{/if}
